import React, { Component } from 'react';
import PropTypes from 'prop-types';

const ymaps = window.ymaps;

export default class MapGeoCollection extends Component {
  static contextTypes = {
    getGeoCollection: PropTypes.func,
  }

  static childContextTypes = {
    getGeoCollection: PropTypes.func.isRequired,
  }

  static defaultProps = {
    visible: true,
  };

  constructor(props) {
    super(props);
    this.collection = new ymaps.GeoObjectCollection();
    this.collection.events.add('click', event => {
      if (this.props.onClick) {
        this.props.onClick(event);
      }
    });
  }

  getChildContext() {
    return {
      getGeoCollection: () => this.collection,
    };
  }

  componentDidMount() {
    if (this.props.visible) {
      this.getParent().add(this.collection);
    }
  }

  componentWillReceiveProps({ visible }) {
    if (visible !== this.props.visible) {
      if (visible) {
        this.getParent().add(this.collection);
      } else {
        this.getParent().remove(this.collection);
      }
    }
  }

  shouldComponentUpdate({ visible }) {
    return visible;
  }

  componentWillUnmount() {
    if (this.getParent()) {
      this.getParent().remove(this.collection);
    }
  }

  getParent = () => this.context.getGeoCollection();

  render() {
    return (
      <React.Fragment>
        {this.props.children}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Map/MapGeoCollection.jsx